import React from "react";
import Theme from '../../../theme.module.css';
import Style from './HeadlessWoocom.module.css';
import CallToAction from "../../callToAction/CallToAction";

export default function HeadlessWoocom({setModalOpen}) {

    return (
        <div>
            <div className={`${Theme.columns} animateColumns`}>
                <div className={Theme.textCont}>
                    <p>We are experts in building and implementing digital commerce solutions: from the initial infrastructure for an ambitious start-up business, to complex enterprise level systems.</p>
                    <br/>
                    <p>WooCommerce is the most used ecommerce platform in the world for good reason. A properly implemented headless solution can provide a cost efficient stepping stone into enterprise level digital commerce. Immediately gain the benefit of modern UX, improved scalability,  extensibility and core web vitals, whilst also ensuring that your tech remains relevant as your business grows.</p>
                </div>
                <div style={{textAlign: "center"}} className={Style.glowBackground}>
                    <img src={require('../../../assets/woocom-react.svg').default} alt="woocom-react" className={Style.woocomReact} />
                </div>
            </div>
            <div className="animateCallToAction">
                <CallToAction text="Get in touch to see how we can grow your commerce business" setModalOpen={setModalOpen} />
            </div>
        </div>
    );
}